import React from 'react';

import { WrapperContainer } from './style';

function WrapWithContainer(WrapperComponent) {
  const ElementWrapper = ({ maxWidth, width, className, wrapperMargin, ...otherProps }) => (
      <WrapperContainer maxWidth={maxWidth} width={width} className={className} margin={wrapperMargin}>
        <WrapperComponent {...otherProps} />
      </WrapperContainer>
    );

  return ElementWrapper;
};

export default WrapWithContainer;
